import { motion } from "framer-motion";

export const BarList = ({ title, rows, total, testId }) => (
  <div data-testid={testId} className="rounded-[28px] border border-white/[0.07] bg-surface/70 p-5 sm:p-6">
    <h3 className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-400">{title}</h3>
    <ul className="mt-5 space-y-4">
      {rows.map(({ key, label, icon, count }) => {
        const pct = total ? Math.round((count / total) * 100) : 0;
        return (
          <li key={key} data-testid={`${testId}-row-${key}`}>
            <div className="flex items-center gap-3">
              {icon}
              <span className="flex-1 truncate text-sm font-medium text-zinc-200">{label}</span>
              <span className="font-mono text-sm text-zinc-50" data-testid={`${testId}-count-${key}`}>{count}</span>
              <span className="w-10 text-right font-mono text-xs text-zinc-400">{pct}%</span>
            </div>
            <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-white/[0.06]">
              <motion.div
                className="h-full rounded-full bg-gold"
                initial={{ width: 0 }}
                animate={{ width: `${pct}%` }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);
